var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"status-code"},[_vm._v(" 404 ")]),_c('p',{staticClass:"text-center title"},[_vm._v(" "+_vm._s(_vm.$messages.pageNotFoundBody)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }